import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const routeLabels = {
  'medicines': 'Medicines', 'inventory': 'Inventory', 'purchases': 'Purchases',
  'sales': 'Sales', 'customers': 'Customers', 'suppliers': 'Suppliers',
  'patients': 'Patients', 'doctors': 'Doctors', 'prescriptions': 'Prescriptions',
  'branches': 'Branches', 'users': 'Users', 'roles': 'Roles',
  'accounting': 'Accounting', 'expenses': 'Expenses', 'reports': 'Reports',
  'audit': 'Audit Logs', 'settings': 'Settings', 'brands': 'Brands',
  'manufacturers': 'Manufacturers', 'taxes': 'Taxes', 'currencies': 'Currencies',
  'strengths': 'Strengths', 'bank-accounts': 'Bank Accounts',
  'requisitions': 'Purchase Requisitions',
};

export default function Breadcrumb() {
  const location = useLocation();
  const paths = location.pathname.split('/').filter(Boolean);

  if (paths.length === 0) return null;

  return (
    <nav className="flex items-center gap-1 text-sm text-gray-500 mb-4">
      <Link to="/" className="flex items-center gap-1 hover:text-blue-600 transition-colors">
        <Home size={14} />
        <span>Home</span>
      </Link>
      {paths.map((segment, idx) => {
        const href = '/' + paths.slice(0, idx + 1).join('/');
        const label = routeLabels[segment] || segment.charAt(0).toUpperCase() + segment.slice(1);
        const isLast = idx === paths.length - 1;
        return (
          <React.Fragment key={segment}>
            <ChevronRight size={14} className="text-gray-300" />
            {isLast ? (
              <span className="text-gray-800 font-medium">{label}</span>
            ) : (
              <Link to={href} className="hover:text-blue-600 transition-colors">{label}</Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
